// extracted by mini-css-extract-plugin
module.exports = {"terms":"_18PLayg","terms_block":"vuUOWrA","tnc_title":"_2BiLygr","check_list":"pbJANE6","tnc_instruction":"_3VE0aoX"};